import { useFormField } from '../../useFormField';
import type { StripControlledProperties } from '../../types';
import type { TextFieldProps } from '../base-fields/TextField';
import { CheckboxField, type CheckboxFieldProps } from '../base-fields/CheckboxField';

interface CheckboxFormFieldProps extends StripControlledProperties<Omit<CheckboxFieldProps, 'isSelected'>> {
	onChangePassthrough?: (selected: boolean) => void;
	textFieldProps?: StripControlledProperties<TextFieldProps>;
	useOneAndZero?: boolean;
}

export function CheckboxFormField(props: CheckboxFormFieldProps) {
	const fieldProps = useFormField<boolean | number | string>(props);

	const onSelectionChange = async (value: boolean) => {
		if (props.useOneAndZero) {
			await fieldProps.onChange(value ? 1 : 0);
		} else {
			await fieldProps.onChange(value);
		}
		props.onChangePassthrough?.(value);
	};

	const isSelected = fieldProps.value === true || fieldProps.value === 1 || fieldProps.value === '1';

	return <CheckboxField {...props} {...fieldProps} value={isSelected} onChange={onSelectionChange} />;
}
